import { callAi } from "./geminiClient";

function getLang() {
  return (typeof document !== "undefined" && document.documentElement?.lang) || "ko";
}

/** 공통: 로그인 확인 (기존 전환 파일들과 동일 스타일) */
function ensureLoginOrThrow(lang) {
  const raw = (typeof localStorage !== "undefined" && localStorage.getItem("user")) || "";
  const user = raw ? JSON.parse(raw) : null;
  if (!user) {
    alert(lang === "zh-CN" ? "请先登录后再使用。" : "로그인 후 사용해 주세요");
    if (typeof window !== "undefined") window.location.href = "/login";
    throw new Error("NOT_AUTHENTICATED");
  }
  return user;
}

/** 레거시 응답 문자열에서 ```json / ``` 제거 후 JSON 파싱 */
function parseJsonFromModel(raw) {
  const s = (raw ?? "")
    .replace(/```json/gi, "")
    .replace(/```/g, "")
    .trim();
  return JSON.parse(s);
}

export const MemoTalkAI = {
  /**
   * 메모 → (CRM 메모, 알림톡) 동시 생성
   * 레거시 memo_talk.js 프롬프트를 언어별로 '그대로' 사용합니다.
   */
  async generate({ memoText }) {
    const lang = getLang();
    const user = ensureLoginOrThrow(lang);

    let prompt = "";
    if (lang === "zh-CN") {
      // 중국어 프롬프트 (레거시 그대로, 주석/표기 포함)
      prompt = `你是 '${process.env.REACT_APP_CN_CLINIC_NAME}' 的优秀CRM教育专家。请看新员工在客户咨询后留下的备忘录，编写一份整洁的备忘录以记录在CRM中，以及一条发送给客户的亲切通知消息。请务必仅以以下JSON格式提供回复。绝对不要添加其他说明。

            新员工备忘录: "${memoText}"

            响应 JSON 格式:
            {
                "memo": "将记录在CRM中的整理后的备忘录内容",
                "message": "将发送给客户的通知消息内容"
            }`;
    } else {
      // 한국어 프롬프트 (레거시 그대로)
      prompt = `당신은 '${process.env.REACT_APP_CLINIC_NAME}'의 유능한 CRM 교육 전문가입니다. 신입 직원이 고객 상담 후 남긴 메모를 보고, CRM에 기록할 깔끔한 메모와 고객에게 발송할 친절한 알림톡 메시지를 작성해주세요. 응답은 반드시 아래의 JSON 형식으로만 제공해야 합니다. 다른 설명은 절대 추가하지 마세요.
                
            신입 직원 메모: "${memoText}"
            
            응답 JSON 형식:
            {
                "memo": "CRM에 기록될 정리된 메모 내용",
                "message": "고객에게 발송될 알림톡 메시지 내용"
            }`;
    }

    const contents = [{ role: "user", parts: [{ text: prompt }] }];

    const data = await callAi({
      contents,
      api_name: "memo_talk", // 레거시와 동일 API name
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });

    // 다양한 필드 호환 (기존 전환 파일 스타일)
    const raw = data?.data?.answer ?? data?.answer ?? data?.text ?? data?.data?.text ?? "";

    const parsed = parseJsonFromModel(raw);
    if (!parsed || typeof parsed.memo !== "string" || typeof parsed.message !== "string") {
      throw new Error("AI 응답 형식이 올바르지 않습니다.");
    }
    return parsed; // { memo, message }
  },
};
